import { Flex, Typography } from '@aloft/toolkit-sui';

import { selectSubjectValueDisplay } from '../redux/features/selectors/selectSubjectValue.ts';
import { useAppSelector } from '../redux/hooks.ts';
import { IndicatedValueInformationIcon } from './IndicatedValueInformationIcon.tsx';

export const IndicatedValue = () => {
  const indicatedValue = useAppSelector(selectSubjectValueDisplay);

  return (
    <Flex flexDirection="row" alignItems="center" gap=".75rem">
      <Typography variant="h2">{`Indicated Cost Value: ${indicatedValue ?? '$ -'}`}</Typography>
      <IndicatedValueInformationIcon propertyId='subject' compIsManuallyAdjusted={false} />
    </Flex>
  );
};
